import { TableHeaderTypes } from '@enums/table.enum';

export const MARKETING_PAGE_SECTION_CONSTANTS = {
  PAGE_SECTIONS: 'COVER PAGE SECTIONS',
  ADD_SECTION: ' ADD SECTION',
  PREVIEW: 'PREVIEW COVER PAGE',
  EDIT_SECTION: 'EDIT SECTION',
  COLUMN_NAME: 'SECTION NAME',
  COLUMN_LAYOUT_TYPE: 'LAYOUT TYPE',
  COLUMN_VISIBILITY: 'VISIBILITY STATUS',
  COLUMN_ACTION: 'ACTIONS',
  STATUS_VISIBLE: 'Visible',
  STATUS_HIDDEN: 'Hidden',
  NO_SECTIONS_FOUND: 'No Sections Found',
  EMPTY_ICON: 'assets/images/svg/empty_section_active.svg',
  ADD_SECTION_HEADING: 'Add Section',
  ADD_SECTION_SUBHEADING: 'Enter section name and select a layout',
  EDIT_SECTION_HEADING: 'EDIT SECTION',
  SECTION_NAME_LABEL: 'Section Name',
  SECTION_NAME_PLACEHOLDER: 'Ex. Section 1 Name',
  SELECT_LAYOUT_LABEL: 'Select Layout',
  CONFIRM_ADD_SECTION: 'ADD SECTION',
  CONFIRM_UPDATE_SECTION: 'UPDATE SECTION',
  CANCEL: 'CANCEL',
  DELETE_SECTION_HEADING: 'Delete Section',
  DELETE_SECTION_CONFIRMATION: 'Are you sure you want to delete this section',
  CONFIRM_DELETE_SECTION: 'DELETE'
} as const;

export const MARKETING_SECTION_HEADING_HIGHLIGHT_INFO_MESSAGE =
  'Give Theme Color to the respective heading text in curly braces { }.\n' +
  'Use \\n for a new line in the heading.';

export const MARKETING_PAGE_SEO_TITLE_MAX_LENGTH = 200;

export const MARKETING_PAGE_SEO_TITLE_MAXLENGTH_MESSAGE =
  'Maximum 60 characters are allowed';

export const MARKETING_PAGE_SECTION_KEYS = {
  NAME: 'name',
  LAYOUT_TYPE: 'layoutType',
  VISIBILITY: 'isVisible',
  ACTION: 'action'
} as const;

export const TABLE_HEADERS = [
  {
    key: MARKETING_PAGE_SECTION_KEYS.NAME,
    label: MARKETING_PAGE_SECTION_CONSTANTS.COLUMN_NAME,
    width: 'w-30 w-m-100'
  },
  {
    key: MARKETING_PAGE_SECTION_KEYS.LAYOUT_TYPE,
    label: MARKETING_PAGE_SECTION_CONSTANTS.COLUMN_LAYOUT_TYPE,
    type: TableHeaderTypes.IMAGE_WITH_TITLE_DESC,
    keyGroup: {
      title: 'layoutTypeLabel',
      desc: 'layoutTypeDescription'
    },
    width: 'w-30 w-m-100'
  },
  {
    key: MARKETING_PAGE_SECTION_KEYS.VISIBILITY,
    label: MARKETING_PAGE_SECTION_CONSTANTS.COLUMN_VISIBILITY,
    type: TableHeaderTypes.TOGGLE,
    width: 'w-20 w-m-100',
    onLabel: MARKETING_PAGE_SECTION_CONSTANTS.STATUS_VISIBLE,
    offLabel: MARKETING_PAGE_SECTION_CONSTANTS.STATUS_HIDDEN
  }
] as const;

export const TABLE_ACTION_COLUMN = {
  label: MARKETING_PAGE_SECTION_CONSTANTS.COLUMN_ACTION,
  width: 'w-15 w-m-100'
} as const;
